const instances = new WeakMap();

class TextImageSliderSection {
  constructor(section) {
    this.section = section;
    this.swiperEl = section.querySelector('[data-swiper]');
    this.delay = parseInt(section.dataset.autoplayDelay, 10) || 5000;
    this.swiper = null;
    this.init();
  }

  init() {
    if (!this.swiperEl || !window.Swiper) return;
    this.swiper = new window.Swiper(this.swiperEl, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      grabCursor: true,
      autoplay: {
        delay: this.delay,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      a11y: { enabled: true },
      observer: true,
      observeParents: true,
      resizeObserver: true,
    });
  }

  destroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

function bootstrap(section) {
  if (!section || instances.has(section)) return;
  if (section.dataset.isSlider !== 'true') return;
  if (parseInt(section.dataset.slideCount, 10) <= 1) return;
  instances.set(section, new TextImageSliderSection(section));
}

function bootstrapAll() {
  document.querySelectorAll('[data-text-image-slider]').forEach(bootstrap);
}

if (window.Swiper) {
  bootstrapAll();
} else {
  window.addEventListener('load', bootstrapAll);
}

document.addEventListener('shopify:section:load', (event) => {
  const section = event.target.querySelector('[data-text-image-slider]');
  if (section) bootstrap(section);
});

document.addEventListener('shopify:section:unload', (event) => {
  const section = event.target.querySelector('[data-text-image-slider]');
  if (!section) return;
  const instance = instances.get(section);
  if (instance) {
    instance.destroy();
    instances.delete(section);
  }
});
